import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { PALETTE, NIVO_THEME, formatShort } from "@react/projects/chantiers_dashboard/components/palette"

const TopClientsChart = ({ data, currency }) => {
  const rows = (data || []).map((row) => ({ name: row.name, value: row.value / 100, count: row.count }))
  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value)

  return (
    <ChartCard
      icon     = "building"
      title    = {I18n.t("contracts_dashboard.charts.top_clients")}
      subtitle = {I18n.t("contracts_dashboard.charts.top_clients_hint")}
      height   = {320}
      empty    = {rows.length === 0 ? I18n.t("contracts_dashboard.charts.empty") : null}
    >
      <ResponsiveBar
        data         = {rows}
        keys         = {["value"]}
        indexBy      = "name"
        layout       = "horizontal"
        margin       = {{ top: 12, right: 30, bottom: 34, left: 190 }}
        padding      = {0.28}
        colors       = {[PALETTE.teal]}
        borderRadius = {3}
        enableLabel  = {false}
        axisBottom   = {{ tickValues: 4, format: (v) => formatShort(v * 100) }}
        axisLeft     = {{ tickSize: 0, tickPadding: 10 }}
        theme        = {NIVO_THEME}
        tooltip      = {({ value, indexValue, data: row }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "7px 11px", fontSize: 11, borderRadius: 6 }}>
            <strong>{indexValue}</strong> · {money(value)}
            <div style={{ opacity: 0.75 }}>
              {I18n.t("contracts_dashboard.charts.contracts_count", { count: row.count })}
            </div>
          </div>
        )}
      />
    </ChartCard>
  )
}

export default TopClientsChart
